import { render, staticRenderFns } from "./MyBadge.vue?vue&type=template&id=b2be4e68&scoped=true"
import script from "./MyBadge.vue?vue&type=script&lang=js"
export * from "./MyBadge.vue?vue&type=script&lang=js"
import style0 from "./MyBadge.vue?vue&type=style&index=0&id=b2be4e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2be4e68",
  null
  
)

export default component.exports